module.exports = __webpack_public_path__ + "img/question.5168cfcf.svg";